

















import { defineComponent, ref, useContext, onMounted } from '@nuxtjs/composition-api';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import { useAuthentication } from '~/composables/auth/useAuthentication';
import { useAlert } from '~/composables/useAlert';
import { useStore } from '~/composables/useStore';
import { url } from '~/utils';
import { APIError } from '~/utils/error';

const errorCodes = ['ec_review_review_not_liked', 'ec_review_review_already_liked'];

export default defineComponent({
  components: {
    AppIcon,
  },
  props: {
    isLiked: {
      type: Boolean,
      default: false,
    },
    commentId: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const { isAuthenticated } = useAuthentication();
    const { openAlert } = useAlert();
    const { i18n, redirect } = useContext();
    let isProcessingLike = false;
    const isToggled = ref(false);

    onMounted(() => {
      // 画像プリロード
      new Image().src = require('~/assets/animations/like-animation.svg');
      new Image().src = require('~/assets/svg/icon_action-good.svg');
    });
    const toggleLike = async () => {
      // 未ログインの状態でアニメーションを再生したくない
      if (!isAuthenticated.value) {
        redirect(url('AUTH_LOGIN'));
        return;
      }
      // 連打対応
      if (isProcessingLike) return;
      try {
        isProcessingLike = true;
        // クチコミの状態によって、該当API（いいね追加・解除）を叩く
        if (props.isLiked) {
          await store.dispatch('modules/reviews/removeLikeFromComment', {
            path: { id: props.commentId },
          });
        } else {
          await store.dispatch('modules/reviews/addLikeToComment', {
            path: { id: props.commentId },
          });
        }
        // 画面アニメーションを再生させる
        isToggled.value = true;
        emit('change', !props.isLiked);
      } catch (error) {
        if (APIError.isAPIError(error)) {
          const isAlreadyRatedCommentError = error.hasCode(errorCodes[0]) || error.hasCode(errorCodes[1]);
          if (isAlreadyRatedCommentError) {
            openAlert({
              message: i18n.t('Common.comments.error').toString(),
            });
            return;
          }
        }
        throw error;
      } finally {
        isProcessingLike = false;
      }
    };
    return { isToggled, toggleLike };
  },
});
